<div class="banner d-lg-flex d-none justify-content-center">
  <h1 class="ms-3 text-white">{{ 'featured.rewards.page.title' | translate }}</h1>
</div>
<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container mt-3">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="0"
  ></fgbcl-marketplace-list>
</div>
